module.exports = "/assets/delice-page/bottle_1.jpg?H9qHQUW";